<template lang="pug">
  svg.svg-sprite(:x="rect.x" :y="rect.y" :width="rect.width" :height="rect.height")
    use(:href="svgId" :xlink:href="svgId")
</template>

<script>
export default {
  name: 'svg-sprite',
  props: {
    id: String,
    rect: {
      type: Object,
      default: () => ({
        x: 0,
        y: 0,
        width: 100,
        height: 100,
      }),
    },
  },

  computed: {
    svgId() {
      return `#${this.id}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.svg-sprite {
}
</style>
